"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import Skeleton from "../../feedback/Skeleton/Skeleton.js";
import { Box } from "@mantine/core";
import { forwardRef } from "react";
import FigureImage from "./FigureImage.js";
import { I as ImageStyles } from "./PlaceholderImage.js";
const _BackgroundImage = forwardRef((props, ref) => {
  const {
    loaded,
    src,
    children,
    alt,
    title,
    width,
    height,
    objectPosition,
    polymorphicProps,
    className,
    overlay,
    overlayOpacity,
    sizes,
    ...rest
  } = props;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...rest,
      pos: width !== "edge" ? "relative" : void 0,
      w: "100%",
      h: "100%",
      className: `${ImageStyles.backgroundImage} ${className}`,
      p: 0,
      ref,
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            className: `${ImageStyles.fill} ${ImageStyles.backgroundImageInner}`,
            "data-width-type": width,
            children: !loaded ? /* @__PURE__ */ jsx(Skeleton, { width, height, className: ImageStyles.fill }) : /* @__PURE__ */ jsx(
              FigureImage,
              {
                sizes,
                overlay,
                overlayOpacity,
                src,
                alt,
                title,
                loaded: true,
                width,
                height,
                fit: "cover",
                objectPosition,
                polymorphicProps: { fill: true, ...polymorphicProps }
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(Box, { className: `${ImageStyles.fill} ${ImageStyles.content}`, children })
      ]
    }
  );
});
const BackgroundImage = _BackgroundImage;
_BackgroundImage.displayName = "BackgroundImage";
export {
  BackgroundImage as default
};
